module.exports = __webpack_public_path__ + "static/img/shuzi3.444b38fe.png";